<template>
  <div>
    <b-row class="component-margin">
      <b-col md=9>
        <seller-select-modal :carrier="carrier" :lasNumber="lasNumber" :memo="memo" :shippingLimitAmount="shippingLimitAmount" @selected="selectedSeller($event)"></seller-select-modal>
      </b-col>
      <b-col md=3 v-if="isWarnDeposit">
        <div class="message-box message-warn">デポジット残額不足</div>
      </b-col>
    </b-row>
    <b-row v-if="memberId !== ''" class="component-margin">
      <b-col md="4">
        <b-row class="component-margin-2r">
          <b-col md="4">
            <b-input v-model="fnsku" @change="selectFnsku()" size="md" placeholder="FNSKU"/>
          </b-col>
          <!-- <b-col md="2">
            <b-button v-if="shippingMode=='1'" @click="changeShippingMode" :disabled="addressInfo != ''"  class="shipping-btn" variant="danger" >→複数箱</b-button>
            <b-button v-else @click="changeShippingMode" :disabled="addressInfo != ''" class="shipping-btn" variant="danger" >→1箱</b-button>
          </b-col> -->
          <b-col md="2">
            <b-button @click="stockShippingInfo" class="shipping-btn" variant="danger" >保存</b-button>
          </b-col>  
          <b-col md="2">
            <b-button @click="getStockShippingInfo" class="shipping-btn" variant="danger" >復元</b-button>
          </b-col>
          <b-col md="2">
            <b-button @click="outputCsv" class="shipping-btn" variant="danger" >出力</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <shipment-plan-summary :items="items" :totalInboundQuantity="totalInboundQuantity" @updateItemQuantity="updateItemQuantity" @updateWkDispRestVolume="($event) => wkDispRestVolume=$event" />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <shipment-plan-deposit :deposit="deposit" :requireDeposit="requireDeposit" :fnumShipping="fnumShipping" :numMatome="numMatome" :isWarnDeposit="isWarnDeposit"/>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="2">
        <b-img v-if="selectedImageUrl !== ''" center width="128" height="128" :src="selectedImageUrl"></b-img>
      </b-col>
      <b-col md="6">
        <b-row>
          <b-col md="5">
            <b-row class="text-window">
              <b-col md="12">
                <!-- ■ 単体発送時 -->
                <div v-if="shippingMode == '1'">
                  <b-row>
                    <b-col md="6" class="padding-off">
                      <b-form-input id="box-size-str" :disabled="selected === '1'" v-model="boxSizeStr" @change="changeBoxSizeFilterNew($event, 0)" size="sm" placeholder="箱サイズ入力"/>
                    </b-col>
                    <b-col md="6" class="padding-right-off text-center">
                      <b-form-group class="margin-bottom-off">
                        <b-form-radio-group id="shipment-type" v-model="selected" @change="changeShipmentType()" :options="shipmentTypes" :disabled="carrier === '1' || addressInfo != ''" name="shipment-type"></b-form-radio-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="component-margin-top-half">
                    <b-col sm="12" class="padding-off">
                      <label for="box-hight-item">高×幅×奥</label>
                      <b-form-input id="box-hight-item" class="box-item" :disabled="boxSizeFilter != '99'" v-model="boxHeight" size="sm" placeholder=""/>
                      <label for="box-width-item">×</label>
                      <b-form-input id="box-width-item" class="box-item" :disabled="boxSizeFilter != '99'" v-model="boxWidth" size="sm" placeholder=""/>
                      <label for="box-lenght-item">×</label>
                      <b-form-input id="box-lenght-item" class="box-item" :disabled="boxSizeFilter != '99'" v-model="boxDepth" size="sm" placeholder=""/>
                      <b-form-input id="box-weight-item" class="box-item-weight" v-model="boxWeight" size="sm" placeholder="重さ"/>
                      <b-button v-if="boxSizeStr !== ''" class="shipping-btn-size" v-b-popover.hover.top="dispBoxInfoMessage()" variant="primary">Size</b-button>
                    </b-col>
                  </b-row>
                  <b-row class="component-margin-top-half2">
                    <b-col md="3" class="padding-off">
                      <!-- <b-form-group class="margin-bottom-off">
                        <b-form-radio-group id="shipment-type" v-model="isIraiRequest" @change="changeShipmentType()" :options="shipmentIraiTypes" :disabled="carrier === '1' || addressInfo != ''" name="shipment-irai-type"></b-form-radio-group>
                      </b-form-group> -->
                      <input type="checkbox" size="md" id="checkboxForIrai" name="checkboxForIrai" v-model="isIraiRequest" :disabled="carrier === '1' || addressInfo != ''"/> 依頼する
                    </b-col>
                    <!-- <b-col md="3" class="padding-off">
                      <b-button @click="registerShipmentForNormal" class="shipping-btn" variant="danger" :disabled="boxWeight == '' || boxHeight == '' || boxWidth == '' || boxDepth == '' || itemQuantity === 0 || shipmentId != '' || addressInfo != '' || selected === ''">納品#1</b-button>
                    </b-col> -->
                    <!-- <b-col md="3" class="padding-right-off">
                      <b-button @click="registerShipmentForIrai" class="shipping-btn" variant="danger" :disabled="boxWeight == '' || boxHeight == '' || boxWidth == '' || boxDepth == '' || itemQuantity === 0 || shipmentId != '' || addressInfo != '' || selected === ''">依頼</b-button>
                    </b-col> -->
                    <b-col md="6" class="padding-right-off">
                      <b-button @click="getInvoiceCSV" class="shipping-btn" variant="danger" :disabled="invoiceUrl == ''">Invoice</b-button>
                    </b-col>
                    <b-col md="3" class="padding-right-off">
                      <b-button @click="resetShipment" class="shipping-btn" variant="primary" :disabled="shipmentId == ''">取消</b-button>
                    </b-col>
                  </b-row>
                  <b-row class="component-margin-top-half2">
                    <b-col md="6" class="padding-off">
                      <b-button @click="registerShipmentForDHL" class="shipping-btn" variant="danger" :disabled="boxWeight == '' || boxHeight == '' || boxWidth == '' || boxDepth == '' || itemQuantity === 0 || shipmentId != '' || addressInfo != '' || selected === ''">DHL</b-button>
                    </b-col>
                    <b-col md="6" class="padding-right-off">
                      <b-button @click="registerShipmentForUPS" class="shipping-btn" variant="danger" :disabled="boxWeight == '' || boxHeight == '' || boxWidth == '' || boxDepth == '' || itemQuantity === 0 || shipmentId != '' || addressInfo != '' || selected === ''">UPS</b-button>
                    </b-col>
                  </b-row>
                </div>
                <!-- ■ 複数箱発送時 -->
                <div v-else>
                  <b-row>
                    <b-col md="6" class="padding-off">
                      <b-button v-b-toggle.collapse-a.collapse-b.collapse-c.collapse-d.collapse-e>箱のサイズを設定</b-button>
                    </b-col>
                    <!-- <b-col md="6" class="padding-right-off text-center">
                      <b-form-group class="margin-bottom-off">
                        <b-form-radio-group id="shipment-type-multi" v-model="selected" :options="shipmentTypes" disabled name="shipment-type-multi"></b-form-radio-group>
                      </b-form-group>
                    </b-col> -->
                  </b-row>
                  <b-row class="component-margin-top-half">
                    <b-col md="12" class="padding-off">
                      <b-collapse id="collapse-a" class="mt-1">
                        <label for="box-hight-item1">1：</label>
                        <!-- <b-select size="sm" v-model="boxSizeFilter1" class="box-selected" @change="changeBoxSizeFilter($event, 1)" :options="boxSizeType"/> -->
                        <b-form-input id="box-size-str" v-model="boxSizeStr1" @change="changeBoxSizeFilterNew($event, 1)" size="sm" placeholder="箱サイズ入力"/>
                        <b-form-input id="box-hight-item1" :disabled="boxSizeFilter1 != '99'" class="component-margin-left box-item" v-model="boxHeight1" size="sm" placeholder=""/>
                        <label for="box-width-item1">×</label>
                        <b-form-input id="box-width-item1" :disabled="boxSizeFilter1 != '99'" class="box-item" v-model="boxWidth1" size="sm" placeholder=""/>
                        <label for="box-lenght-item1">×</label>
                        <b-form-input id="box-lenght-item1" :disabled="boxSizeFilter1 != '99'" class="box-item" v-model="boxDepth1" size="sm" placeholder=""/>
                        <b-form-input id="box-weight-item1" class="box-item-weight" v-model="boxWeight1" size="sm" placeholder="重さ"/>
                      </b-collapse>
                      <b-collapse id="collapse-b" class="mt-1">
                        <label for="box-hight-item2">2：</label>
                        <b-select size="sm" v-model="boxSizeFilter2" class="box-selected" @change="changeBoxSizeFilter($event, 2)" :options="boxSizeType"/>
                        <b-form-input id="box-size-str" v-model="boxSizeStr2" @change="changeBoxSizeFilterNew($event, 2)" size="sm" placeholder="箱サイズ入力"/>
                        <b-form-input id="box-hight-item2" :disabled="boxSizeFilter2 != '99'" class="component-margin-left box-item" v-model="boxHeight2" size="sm" placeholder=""/>
                        <label for="box-width-item2">×</label>
                        <b-form-input id="box-width-item2" :disabled="boxSizeFilter2 != '99'" class="box-item" v-model="boxWidth2" size="sm" placeholder=""/>
                        <label for="box-lenght-item2">×</label>
                        <b-form-input id="box-lenght-item2" :disabled="boxSizeFilter2 != '99'" class="box-item" v-model="boxDepth2" size="sm" placeholder=""/>
                        <b-form-input id="box-weight-item2" class="box-item-weight" v-model="boxWeight2" size="sm" placeholder="重さ"/>
                      </b-collapse>
                      <b-collapse id="collapse-c" class="mt-1">
                        <label for="box-hight-item3">3：</label>
                        <b-select size="sm" v-model="boxSizeFilter3" class="box-selected" @change="changeBoxSizeFilter($event, 3)" :options="boxSizeType"/>
                        <b-form-input id="box-size-str" v-model="boxSizeStr3" @change="changeBoxSizeFilterNew($event, 3)" size="sm" placeholder="箱サイズ入力"/>
                        <b-form-input id="box-hight-item3" :disabled="boxSizeFilter3 != '99'" class="component-margin-left box-item" v-model="boxHeight3" size="sm" placeholder=""/>
                        <label for="box-width-item3">×</label>
                        <b-form-input id="box-width-item3" :disabled="boxSizeFilter3 != '99'" class="box-item" v-model="boxWidth3" size="sm" placeholder=""/>
                        <label for="box-lenght-item3">×</label>
                        <b-form-input id="box-lenght-item3" :disabled="boxSizeFilter3 != '99'" class="box-item" v-model="boxDepth3" size="sm" placeholder=""/>
                        <b-form-input id="box-weight-item3" class="box-item-weight" v-model="boxWeight3" size="sm" placeholder="重さ"/>
                      </b-collapse>
                      <b-collapse id="collapse-d" class="mt-1">
                        <label for="box-hight-item4">4：</label>
                        <b-select size="sm" v-model="boxSizeFilter4" class="box-selected" @change="changeBoxSizeFilter($event, 4)" :options="boxSizeType"/>
                        <b-form-input id="box-size-str" v-model="boxSizeStr4" @change="changeBoxSizeFilterNew($event, 4)" size="sm" placeholder="箱サイズ入力"/>
                        <b-form-input id="box-hight-item4" :disabled="boxSizeFilter4 != '99'" class="component-margin-left box-item" v-model="boxHeight4" size="sm" placeholder=""/>
                        <label for="box-width-item4">×</label>
                        <b-form-input id="box-width-item4" :disabled="boxSizeFilter4 != '99'" class="box-item" v-model="boxWidth4" size="sm" placeholder=""/>
                        <label for="box-lenght-item4">×</label>
                        <b-form-input id="box-lenght-item4" :disabled="boxSizeFilter4 != '99'" class="box-item" v-model="boxDepth4" size="sm" placeholder=""/>
                        <b-form-input id="box-weight-item4" class="box-item-weight" v-model="boxWeight4" size="sm" placeholder="重さ"/>
                      </b-collapse>
                      <b-collapse id="collapse-e" class="mt-1">
                        <label for="box-hight-item5">5：</label>
                        <b-select size="sm" v-model="boxSizeFilter5" class="box-selected" @change="changeBoxSizeFilter($event, 5)" :options="boxSizeType"/>
                        <b-form-input id="box-size-str" v-model="boxSizeStr5" @change="changeBoxSizeFilterNew($event, 5)" size="sm" placeholder="箱サイズ入力"/>
                        <b-form-input id="box-hight-item5" :disabled="boxSizeFilter5 != '99'" class="component-margin-left box-item" v-model="boxHeight5" size="sm" placeholder=""/>
                        <label for="box-width-item5">×</label>
                        <b-form-input id="box-width-item5" :disabled="boxSizeFilter5 != '99'" class="box-item" v-model="boxWidth5" size="sm" placeholder=""/>
                        <label for="box-lenght-item5">×</label>
                        <b-form-input id="box-lenght-item5" :disabled="boxSizeFilter5 != '99'" class="box-item" v-model="boxDepth5" size="sm" placeholder=""/>
                        <b-form-input id="box-weight-item5" class="box-item-weight" v-model="boxWeight5" size="sm" placeholder="重さ"/>
                      </b-collapse>
                      <b-collapse id="collapse-e" class="mt-1">
                        <label for="box-hight-item6">6：</label>
                        <b-select size="sm" v-model="boxSizeFilter6" class="box-selected" @change="changeBoxSizeFilter($event, 6)" :options="boxSizeType"/>
                        <b-form-input id="box-size-str" v-model="boxSizeStr6" @change="changeBoxSizeFilterNew($event, 6)" size="sm" placeholder="箱サイズ入力"/>
                        <b-form-input id="box-hight-item6" :disabled="boxSizeFilter6 != '99'" class="component-margin-left box-item" v-model="boxHeight6" size="sm" placeholder=""/>
                        <label for="box-width-item6">×</label>
                        <b-form-input id="box-width-item6" :disabled="boxSizeFilter6 != '99'" class="box-item" v-model="boxWidth6" size="sm" placeholder=""/>
                        <label for="box-lenght-item6">×</label>
                        <b-form-input id="box-lenght-item6" :disabled="boxSizeFilter6 != '99'" class="box-item" v-model="boxDepth6" size="sm" placeholder=""/>
                        <b-form-input id="box-weight-item6" class="box-item-weight" v-model="boxWeight6" size="sm" placeholder="重さ"/>
                      </b-collapse>
                    </b-col>
                  </b-row>
                  <b-row class="component-margin-top-half2">
                    <b-col md="3" class="padding-off">
                      <b-button @click="registerShipmentForMultiBoxNormal" class="shipping-btn" variant="danger" :disabled="boxWeight1 == '' || boxHeight1 == '' || boxWidth1 == '' || boxDepth1 == '' || boxWeight2 == '' || boxHeight2 == '' || boxWidth2 == '' || boxDepth2 == '' || itemQuantity === 0 || shipmentId != '' || addressInfo != ''">納品#1</b-button>
                    </b-col>
                    <b-col md="3" class="padding-right-off">
                      <b-button @click="registerShipmentForMultiBoxIrai" class="shipping-btn" variant="danger" :disabled="boxWeight1 == '' || boxHeight1 == '' || boxWidth1 == '' || boxDepth1 == '' || boxWeight2 == '' || boxHeight2 == '' || boxWidth2 == '' || boxDepth2 == '' || itemQuantity === 0 || shipmentId != '' || addressInfo != ''">依頼</b-button>
                    </b-col>
                    <b-col md="4" class="padding-right-off">
                      <b-button @click="getInvoiceCSV" class="shipping-btn" variant="danger" :disabled="invoiceUrl == ''">Invoice</b-button>
                    </b-col>
                    <b-col md="2" class="padding-right-off">
                      <b-button @click="resetShipment" class="shipping-btn" variant="primary" :disabled="addressInfo == '' || shipmentId == ''">取消</b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col v-if="shippingMode == '1'" md="5" offset-md="1">
            <b-row class="text-window-orange">
              <b-col md="12">
                <b-row>
                  <b-col md="5" class="padding-off">
                    <b-form-input id="shipment-id" class="width-90" v-model="shipmentId" size="sm" placeholder="ShipmentId"/>
                  </b-col>
                  <b-col md="2" class="padding-off">
                    <b-button v-show="selectedShipmentType === '0'" class="shipping-btn" disabled>-</b-button>
                    <b-button v-show="selectedShipmentType === '1' || selectedShipmentType === '4'" class="shipping-btn" variant="primary" disabled>Fedex</b-button>
                    <b-button v-show="selectedShipmentType === '2' || selectedShipmentType === '3'" class="shipping-btn" variant="danger" disabled>DHL</b-button>
                  </b-col>
                  <b-col md="5" class="padding-right-off">
                    <b-form-input v-model="traceNumber" size="sm" placeholder="追跡番号"/>
                  </b-col>
                </b-row>
                <b-row class="component-margin-top-half">
                  <b-col md="12" class="padding-off">
                    <b-form-textarea class="height-2 width-max" v-model="addressInfo" :disabled=true size="sm" placeholder=""/>
                  </b-col>
                </b-row>
                <b-row class="component-margin-top-half">
                  <b-col md="6" class="padding-off">
                    <b-button @click="registerShipmentAfter" class="shipping-btn" variant="danger" :disabled="shipmentId == '' || traceNumber == '' || selected == '1'">納品#2</b-button>
                    <!-- <b-button @click="registerShipmentAfter" class="shipping-btn" variant="danger" :disabled="shipmentId == '' || traceNumber == ''">納品#2</b-button> -->
                  </b-col>
                  <b-col md="6" class="padding-right-off">
                    <b-button @click="getShipmentLabel" class="shipping-btn" variant="danger" :disabled="selected == '1'">Label</b-button>
                    <!-- <b-button @click="getShipmentLabel" class="shipping-btn" variant="danger" :disabled="shipmentLabelUrl == '' || selected == '1'">Label</b-button> -->
                    <!-- <b-button @click="getShipmentLabel" class="shipping-btn" variant="danger" :disabled="shipmentId == ''">Label</b-button> -->
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col v-else md="5" offset-md="1">
            <b-row class="text-window-orange">
              <b-col md="12">
                <b-row>
                  <b-col md="5" class="padding-off">
                    <b-form-input id="shipment-id" class="width-90" v-model="shipmentId" size="sm" placeholder="ShipmentId"/>
                  </b-col>
                  <b-col md="2" class="padding-off">
                    <b-button v-show="selectedShipmentType === '0'" class="shipping-btn" disabled>-</b-button>
                    <b-button v-show="selectedShipmentType === '1' || selectedShipmentType === '4'" class="shipping-btn" variant="primary" disabled>Fedex</b-button>
                    <b-button v-show="selectedShipmentType === '2' || selectedShipmentType === '3'" class="shipping-btn" variant="danger" disabled>DHL</b-button>
                  </b-col>
                  <b-col md="5" class="padding-right-off">
                    <b-button v-b-toggle.collapse-f.collapse-g.collapse-h.collapse-i.collapse-j>追跡番号を設定</b-button>
                    <!-- <b-form-input v-model="traceNumber" size="sm" placeholder="追跡番号"/> -->
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12" class="padding-off">
                    <b-collapse id="collapse-f" class="mt-1">
                      <label for="box-tracking-number1">1/ 追跡番号：</label>
                      <b-form-input id="box-tracking-number1" class="box-tracking" v-model="traceNumber1" size="sm" placeholder=""/>
                    </b-collapse>
                    <b-collapse id="collapse-g" class="mt-1">
                      <label for="box-tracking-number2">2/ 追跡番号：</label>
                      <b-form-input id="box-tracking-number2" class="box-tracking" v-model="traceNumber2" size="sm" placeholder=""/>
                    </b-collapse>
                    <b-collapse id="collapse-h" class="mt-1">
                      <label for="box-tracking-number3">3/ 追跡番号：</label>
                      <b-form-input id="box-tracking-number3" class="box-tracking" v-model="traceNumber3" size="sm" placeholder=""/>
                    </b-collapse>
                    <b-collapse id="collapse-i" class="mt-1">
                      <label for="box-tracking-number4">4/ 追跡番号：</label>
                      <b-form-input id="box-tracking-number4" class="box-tracking" v-model="traceNumber4" size="sm" placeholder=""/>
                    </b-collapse>
                    <b-collapse id="collapse-j" class="mt-1">
                      <label for="box-tracking-number5">5/ 追跡番号：</label>
                      <b-form-input id="box-tracking-number5" class="box-tracking" v-model="traceNumber5" size="sm" placeholder=""/>
                    </b-collapse>
                    <b-collapse id="collapse-j" class="mt-1">
                      <label for="box-tracking-number6">6/ 追跡番号：</label>
                      <b-form-input id="box-tracking-number6" class="box-tracking" v-model="traceNumber6" size="sm" placeholder=""/>
                    </b-collapse>
                  </b-col>
                </b-row>
                <b-row class="component-margin-top-half">
                  <b-col md="12" class="padding-off">
                    <b-form-textarea class="height-2 width-max" v-model="addressInfo" :disabled=true size="sm" placeholder=""/>
                  </b-col>
                </b-row>
                <b-row class="component-margin-top-half">
                  <b-col md="6" class="padding-off">
                    <b-button @click="registerShipmentAfterForMulti" class="shipping-btn" variant="danger" :disabled="shipmentId == '' || traceNumber1 == '' || traceNumber2 == ''">納品#2</b-button>
                  </b-col>
                  <b-col md="6" class="padding-right-off">
                    <!-- <b-button @click="getShipmentLabel" class="shipping-btn" variant="danger" :disabled="shipmentLabelUrl == ''">Label</b-button> -->
                    <b-button @click="getShipmentLabel" class="shipping-btn" variant="danger">Label</b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="memberId !== ''">
      <b-col sm="12">
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                :items="filteredItems" :fields="fields">
                <!-- :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"> -->
          <template slot="productImageUrl" slot-scope="row">
            <b-img center width="50" height="50" @click="selectImage(row.value)" :src="row.value"></b-img>
          </template>
          <template slot="quantity" slot-scope="row">
            <b-row>
              <b-col>
                <b-form-input class="text-right" v-model="row.item['quantity']" :disabled="(row.item['status'] != '' && row.item['status'] != '05' && row.item['status'].indexOf('91') === -1) || row.item['statusOther'] != '' || row.item['delete']"></b-form-input>
              </b-col>
            </b-row>
          </template>
          <template slot="price" slot-scope="row">
            <label>{{formatPrice(culcPurchaseAmount(row.item))}}</label>
          </template>
          <template slot="boxNumber" slot-scope="row">
            <b-row>
              <b-col>
                <b-form-input class="text-right" v-model="row.item['boxNumber']" :disabled="shippingMode == '1' || row.item['status'] != '' || row.item['statusOther'] != '' || row.item['delete']"></b-form-input>
              </b-col>
            </b-row>
          </template>
          <template slot="status" slot-scope="row">
            <div v-for='(value, index) in getStatusList(row.item)' :key='index'>
              {{ value }}
            </div>
          </template>
          <template slot="comment" slot-scope="row">
            <div v-for='(value, index) in getCommentList(row.item)' :key='index'>
              {{ value }}
            </div>
          </template>
          <template slot="delete" slot-scope="row">
            <input type="checkbox" v-model="row.item['delete']" @change="changeDef()" class="big-checkbox">
          </template>
          <template slot="trouble" slot-scope="row">
            <b-button size="sm" @click="troubleModal(row)" :disabled="row.item['quantity'] == '0'" variant="dark">管</b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-modal ref="checkStockVolume" @ok="checkStockVolume" hide-header>
      <div class="text-center"><label>{{confirmMessage}}</label></div>
      <b-row class="component-margin">
        <b-col sm="12">
          <b-input v-model="inputStockVolume" :placeholder="在庫数"/>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ref="checkStockVolumeResult" @ok="getInvoiceCSVCore" hide-header>
      <div class="text-center"><label>{{confirmMessage}}</label></div>
    </b-modal>
    <b-modal ref="confirmMessageForNext" @ok="onNext1" hide-header>
      <div class="text-center"><label>{{confirmMessage}}</label></div>
    </b-modal>
    <b-modal ref="confirmMessageForNext2" @ok="onNext2" hide-header>
      <div class="text-center"><label>{{confirmMessage}}</label></div>
    </b-modal>
    <b-modal ref="confirmMessageForMatome20" @ok="shipmentNotCheckMatome" hide-header>
      <div class="text-center"><label>{{confirmMessage}}</label></div>
    </b-modal>
    <b-modal ref="confirmMessage" ok-only hide-header>
      <div class="text-center"><label>{{confirmMessage}}</label></div>
    </b-modal>
    <b-modal ref="messagePopup" @ok="handleTroblePrintOk" hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
    <b-modal ref="sendCheckPopup" @ok="checkRequiredWarning" hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
    <b-modal ref="messageQuantityCheck" @ok="shipmentCore" hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
    <b-modal ref="messageQuantityCheckForMulti" @ok="shipmentCoreForMulti" hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
    <b-modal ref="messagePopupSimple2" @ok="fnskuProcess" hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
    <b-modal ref="messageWithHeader" :title="popupTitle" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow" hide-header-close hide-footer>
      <div class="text-center">{{confirmMessage}}</div>
      <hr class="modal-divider">
      <div class="right-aligned">
        <b-checkbox size="md" id="memoCheckboxInModal" name="memoCheckboxInModal" v-model="memoCheckboxInModal">チェック済み</b-checkbox>
        <b-button size="md" @click="closeMemoPopup()" :disabled="!memoCheckboxInModal" variant="primary">OK</b-button>
      </div>
    </b-modal>
    <!-- <b-modal ref="messageWithHeader" :title="popupTitle" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" @ok="dispMessageAfterSelectedSeller">
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal> -->
    <b-modal ref="troubleModal" title="管理品登録" @ok="handleTroubleOk" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow">
      <b-form-group size="sm" horizontal label="問題内容" label-class="text-sm-right" label-for="troubleSelect">
        <b-select size="sm" v-model="selectedTroubleType" :options="reasonTypes" label-for="troubleSelect"/>
        <!-- <b-form-radio-group v-model="selectedTroubleType" class="pt-2" :options="troubleShippingTypes" label-for="troubleSelect"></b-form-radio-group> -->
      </b-form-group>
      <b-form-group v-show="selectedTroubleType === '12'" size="sm" horizontal label="その他" label-class="text-sm-right" label-for="reasonCodeOther">
        <b-form-input size="sm" id="reasonCodeOther" v-model="reasonCodeOther" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="ロケーション番号" label-class="text-sm-right" label-for="locationNumberSelect">
        <b-form-input size="sm" id="locationNumber" v-model="locationNumber" type="text"/>
        <!-- <b-form-select size="sm" id="locationNumberSelect" v-model="locationNumberFilter" :options="locationTypes"></b-form-select> -->
      </b-form-group>
    </b-modal>
  </div>
  
</template>

<script>
import Vue from 'vue';
import BoxSizeType from '@/types/BoxSizeType';
import BaseComponent from '@/components/BaseComponent';
import SellerSelectModal from '@/components/common/SellerSelectModal';
import ShipmentPlanSummary from '@/components/shipment-plan/ShipmentPlanSummary';
import ShipmentPlanDeposit from '@/components/shipment-plan/ShipmentPlanDeposit';
import ShipmentType2 from '@/types/ShipmentType2';
import ReasonType from '@/types/ReasonType';
import LocationType from '@/types/LocationType';
import ShipmentIraiType from '@/types/ShipmentIraiType';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  data() {
    return {
      items: [],
      // itemsForMulti: [],
      boxSizeType: BoxSizeType.filterValues(),
      // fields: [
      //   { key: 'number', label: '番号', sortable: true, variant: 'base', class: 'table-cw6' },
      //   { key: 'fnsku', label: 'FNSKU', sortable: true, variant: 'base', class: 'table-lw10' },
      //   { key: 'productImageUrl', label: '画像', sortable: true, variant: 'base', class: 'table-cw6' },
      //   { key: 'productCondition', label: '状態', sortable: true, variant: 'base', class: 'table-lw5' },
      //   { key: 'productNameEn', label: '商品名(英)', sortable: true, variant: 'base', class: '' },
      //   { key: 'quantity', label: '数量', sortable: true, variant: 'warning', class: 'table-rw6' },
      //   { key: 'sku', label: 'SKU', sortable: true, variant: 'warning', class: 'table-lw15' },
      //   { key: 'asin', label: 'ASIN', sortable: true, variant: 'warning', class: 'table-lw10' },
      //   { key: 'status', label: 'status', sortable: true, variant: 'warning', class: 'table-lw15' },
      //   { key: 'delete', label: '削除', sortable: true, variant: 'warning', class: 'table-cw6' },
      // ],
      fields: [
        // { key: 'number', label: '番号', sortable: true, variant: 'base', class: 'table-cw6' },
        { key: 'fnsku', label: 'FNSKU', sortable: false, variant: 'base', class: 'table-lw8' },
        { key: 'productImageUrl', label: '画像', sortable: false, variant: 'base', class: 'table-cw6' },
        // { key: 'productCondition', label: '状態', sortable: true, variant: 'base', class: 'table-lw5' },
        { key: 'productNameEn', label: '商品名(英)', sortable: false, variant: 'base', class: '' },
        { key: 'price', label: '購入額', sortable: false, variant: 'base', class: 'table-rw6' },
        { key: 'boxNumber', label: '箱番号', sortable: false, variant: 'warning', class: 'table-rw6' },
        { key: 'inboundQuantity', label: '入庫数', sortable: false, variant: 'warning', class: 'table-rw6' },
        { key: 'quantity', label: '数量', sortable: false, variant: 'warning', class: 'table-rw6' },
        { key: 'sku', label: 'SKU', sortable: false, variant: 'warning', class: 'table-lw15' },
        { key: 'asin', label: 'ASIN', sortable: false, variant: 'warning', class: 'table-lw8' },
        { key: 'comment', label: '備考', sortable: false, variant: 'warning', class: '' },
        { key: 'status', label: 'status', sortable: false, variant: 'warning', class: 'table-lw10' },
        { key: 'trouble', label: '管理', variant: 'warning', class: 'table-cw6' },
        { key: 'delete', label: '削除', sortable: false, variant: 'warning', class: 'table-cw6' },
      ],
      boxSizeStr: '',
      boxSizeStr1: '',
      boxSizeStr2: '',
      boxSizeStr3: '',
      boxSizeStr4: '',
      boxSizeStr5: '',
      boxSizeStr6: '',
      boxSizeFilter: '99',
      boxSizeFilter1: '99',
      boxSizeFilter2: '99',
      boxSizeFilter3: '99',
      boxSizeFilter4: '99',
      boxSizeFilter5: '99',
      boxSizeFilter6: '99',
      locationNumber: '',
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      pageOptions: [ 25, 50, 100 ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: '',
      activate: false,
      fnsku: '',
      memberId: '',
      member_name: '',
      lasNumber: '0',
      shippingLimitAmount: 9999,
      traceNumber: '',
      traceNumber1: '',
      traceNumber2: '',
      traceNumber3: '',
      traceNumber4: '',
      traceNumber5: '',
      traceNumber6: '',
      boxHeight: '',
      boxWidth: '',
      boxDepth: '',
      boxWeight: '',
      boxHeight1: '',
      boxWidth1: '',
      boxDepth1: '',
      boxWeight1: '',
      boxHeight2: '',
      boxWidth2: '',
      boxDepth2: '',
      boxWeight2: '',
      boxHeight3: '',
      boxWidth3: '',
      boxDepth3: '',
      boxWeight3: '',
      boxHeight4: '',
      boxWidth4: '',
      boxDepth4: '',
      boxWeight4: '',
      boxHeight5: '',
      boxWidth5: '',
      boxDepth5: '',
      boxWeight5: '',
      boxHeight6: '',
      boxWidth6: '',
      boxDepth6: '',
      boxWeight6: '',
      boxSizeStr: '',
      boxWeightPound : '',
      memo: '',
      headerBgVariant: 'danger',
      headerTextVariant: 'light',
      selectedImageUrl: '',
      totalInboundQuantity: '0',
      totalSku: 0,
      totalProcut: 0,
      totalWeight: 0,
      totalAmount: 0,
      modalInfo: { title: '', content: '' },
      confirmMessage: '',
      itemQuantity: 0,
      depositWarn: '0',
      isWarnDeposit: false,
      memoCheckboxInModal: false,
      carrier: '',
      addressInfo: '',
      shipmentId: '',
      invoiceUrl: '',
      shipmentLabelUrl: '',
      // hasShippment: false,
      fnskuCheckItem: {},
      addressInfox: {},
      editItem: {},
      rowCopy: {},
      selected: '0',
      selectedTroubleType: '0',
      reasonCodeOther: '',
      isBoxNumberNull: false,
      isReInboundMode: false,
      isRequiredCheckMatomeOver20: true,
      selectedShipmentType: '0',
      shipmentTypes: ShipmentType2.values(),
      reasonTypes: ReasonType.values1(),
      locationTypes: LocationType.values(),
      shipmentIraiTypes: ShipmentIraiType.values(),
      // getTroubleValue: TroubleShippingType.valueOf(),
      shippingMode: '1',
      deposit: 0,
      requireDeposit: 0,
      fnumShipping: 0,
      numMatome: 0,
      troubleProductInfo: '',
      isIncludeLargeItem: false,
      inputStockVolume: 0,
      wkDispRestVolume: 0,
      indicateCarrier: 'dhl',
      isIraiRequest: false
    };
  },
  computed: {
    filteredItems() {
      let filteredItems = this.items.filter(item => {
        return ((this.filter === '' || item.productNameEn.indexOf(this.filter) !== -1) ||
                (this.filter === '' || item.asin.indexOf(this.filter) !== -1));
        });
      this.totalRows = filteredItems.length;
      // this.currentPage = 1;
      return filteredItems;
    }
  },
  methods: {
    selectedSeller($event) {
      this.memberId = $event.amazonAccount;
      api.getBoxInfo(this.memberId, (data) => {
        this.deposit = data.deposit;
        this.requireDeposit = data.requireDeposit;
        this.fnumShipping = data.fnumShipping;
        this.numMatome = data.totalInboundQuantityMatome;
        this.depositWarn = data.depositWarn;
        this.isWarnDeposit = data.isWarnDeposit;
        this.carrier = data.carrier;
        this.totalInboundQuantity = data.totalInboundQuantity;
        this.lasNumber = data.lasNumber;
        if(data.carrier === '1'){
          this.selected = '0';
        }
        this.memo = data.memo;
        if(this.memo !== ''){
          this.popupTitle = '指定会員の注意事項'
          this.confirmMessage = this.memo;
          this.$refs.messageWithHeader.show();
        }
        this.shippingLimitAmount = data.shippingLimitAmount;
        this.items = [];
        this.itemsForMulti = [];
        this.shipmentId = '';
        this.addressInfo = '';
        this.invoiceUrl = '';
        this.selectedImageUrl = '';
        
        this.boxSizeStr = '';
        this.boxSizeStr1 = '';
        this.boxSizeStr2 = '';
        this.boxSizeStr3 = '';
        this.boxSizeStr4 = '';
        this.boxSizeStr5 = '';
        this.boxSizeStr6 = '';
        this.boxSizeFilter = '99';
        this.boxSizeFilter1 = '99';
        this.boxSizeFilter2 = '99';
        this.boxSizeFilter3 = '99';
        this.boxSizeFilter4 = '99';
        this.boxSizeFilter5 = '99';
        this.boxSizeFilter6 = '99';
        this.traceNumber = '';
        this.traceNumber1 = '';
        this.traceNumber2 = '';
        this.traceNumber3 = '';
        this.traceNumber4 = '';
        this.traceNumber5 = '';
        this.traceNumber6 = '';
        this.boxHeight = '';
        this.boxHeight1 = '';
        this.boxHeight2 = '';
        this.boxHeight3 = '';
        this.boxHeight4 = '';
        this.boxHeight5 = '';
        this.boxHeight6 = '';
        this.boxWidth = '';
        this.boxWidth1 = '';
        this.boxWidth2 = '';
        this.boxWidth3 = '';
        this.boxWidth4 = '';
        this.boxWidth5 = '';
        this.boxWidth6 = '';
        this.boxDepth = '';
        this.boxDepth1 = '';
        this.boxDepth2 = '';
        this.boxDepth3 = '';
        this.boxDepth4 = '';
        this.boxDepth5 = '';
        this.boxDepth6 = '';
        this.boxWeight = '';
        this.boxWeight1 = '';
        this.boxWeight2 = '';
        this.boxWeight3 = '';
        this.boxWeight4 = '';
        this.boxWeight5 = '';
        this.boxWeight6 = '';
        this.boxSizeStr = '',
        this.boxWeightPound = '',
        this.isIncludeLargeItem = false,
        this.isIraiRequest = false;
      });
    },
    closeMemoPopup(){
      this.$refs.messageWithHeader.hide();
      this.memoCheckboxInModal = false;
    },
    dispMessageAfterSelectedSeller(){
      if(this.isWarnDeposit){
        this.confirmMessage = 'デポジット残額が不足しています。リストに入力して連絡をして下さい';
        this.$refs.confirmMessage.show();
      }
    },
    changeShipmentType(){
      if(this.selected === '1'){
        // this.boxSizeFilter = '99';
        // this.changeBoxSizeFilter('99', 0);
        this.boxSizeStr = '';
        this.changeBoxSizeFilterNew(this.boxSizeStr, 0);
      } else{
        // this.boxSizeFilter = '9';
        // this.changeBoxSizeFilter('9', 0);
        this.boxSizeStr = 'TOKUSYU';
        this.changeBoxSizeFilterNew(this.boxSizeStr, 0);
      }
    },
    selectFnsku() {
      if (this.memberId !== null && this.memberId !== '' && this.fnsku !== null && this.fnsku !== '' && this.fnsku.length === 10) {
        api.registerShipmentPlan(this.memberId, this.fnsku, (item) => {
          // FNSKUが未登録の場合は処理スキップ（想定外）
          if(item.fnsku === null || item.fnsku === '') {
            return;
          }
          // メイン処理
          this.fnskuCheckItem = item;
          if(item.errorSendValue !== null && item.errorSendValue !== ''){
            this.confirmMessage = '輸出禁止の商品です。発送処理に加えますか？（ASIN:' + item.asin + ' /' + item.errorSendValue + ')';
            this.$refs.sendCheckPopup.show();
            return;
          }
          this.checkRequiredWarning();
        });
      }
    },
    checkRequiredWarning(){
      if(this.fnskuCheckItem['asin'] === 'B002SE3DI2' || this.fnskuCheckItem['asin'] === 'B002SE3DJ6' || this.fnskuCheckItem['asin'] === 'B002SE1X34' || this.fnskuCheckItem['asin'] === 'B002SDW3AW' || this.fnskuCheckItem['asin'] === 'B002SE1X2A' || this.fnskuCheckItem['productNameEn'].includes('Nagaoka ')){
        this.confirmMessage = '⚠️Transparency認証コードを隠さずに入庫・発送⚠️';
        this.$refs.messagePopupSimple2.show();
        return;
      } 
      this.fnskuProcess();
    },
    fnskuProcess(){
      this.fnskuCheckItem.number = this.items.length + 1;
      this.items.unshift(this.fnskuCheckItem);
      if(this.shippingMode === '1'){
        this.fnskuCheckItem['boxNumber'] = '1';
      }else{
        this.fnskuCheckItem['boxNumber'] = '';
      }
      this.fnskuCheckItem['delete'] = false;
      this.selectedImageUrl = this.fnskuCheckItem['productImageUrl'];
      this.fnsku = '';
      // this.calculateSummary();
      if(this.fnskuCheckItem['sizeType'] === '2'){
        this.isIncludeLargeItem = true;
      }
      if(this.fnskuCheckItem.isNotInbound){
        if(this.fnskuCheckItem.isExistLost){
          this.confirmMessage = '不明品として登録されている商品です';
        } else{
          this.confirmMessage = '本商品は入庫されていません';
        }
        this.$refs.confirmMessageForNext.show();
      } else{
        this.onNext1();
      }
    },
    onNext1(){
      // 商品登録時のバーコード選択ミス商品チェック（ポップアップ警告）
      if(this.fnskuCheckItem['fnsku'].substring(0,1) === 'B'){
        this.confirmMessage = '商品登録時のバーコード選択ミスの商品です。(FNSKUがBから始まる文言になっている）';
        this.$refs.confirmMessageForNext2.show();
        this.addCellVariant(this.items);
      } else{
        this.onNext2();
      }
    },
    onNext2(){
      // 返品商品が含まれるかをチェック（ポップアップ警告）
      if(this.fnskuCheckItem['status'].indexOf('05') !== -1){
        this.confirmMessage = '返品依頼対象商品です。';
        this.$refs.confirmMessage.show();
      }
    },
    changeDef(){
      this.isIncludeLargeItem = false;
      for (let item of this.items) {
        if(item['delete']){
          continue;
        }
        if(item['sizeType'] === '2'){
          this.isIncludeLargeItem = true;
          break;
        }
      }
    },
    stockShippingInfo(){
      api.stockShippingInfo(this.memberId, this.items, (data) => {
        this.confirmMessage = 'データを保存しました';
        this.$refs.confirmMessage.show();
      });
    },
    getStockShippingInfo(){
      api.getStockShippingInfo(this.memberId, (data) => {
        this.items = data.shipmentStockList;
        if(data.sizeType === '2'){
          this.isIncludeLargeItem = true;
        }
        this.confirmMessage = 'データを復元しました。';
        this.$refs.confirmMessage.show();
      });
    },
    outputCsv() {
      let header = '\ufeff' + 'FNSKU,商品名,購入単価,箱番号,入庫数,数量,SKU,ASIN,状態,備考,STATUS\n';
      let ids = ['fnsku', 'productNameEn', 'price', 'boxNumber', 'inboundQuantity', 'quantity', 'sku', 'asin', 'productCondition', 'comment', 'status'];
      this.outputFile(this.items, header, ids, 'shippingInfo.csv');
    },
    outputFile(items, header, ids, fileName) {
      let csv = header;
      for (const item of items) {
        // 削除フラグがONの場合は処理対象外
        if(item['delete']){
          continue;
        }
        csv = csv + '"';
        for (const id of ids) {
          if (item[id] == null || item[id] === '') {
            csv += '-","';
          } else{
            if(id === 'status'){
              let statusStr = '-';
              if (item[id] ==='98') {
                statusStr = 'エラー有';
              } else if(item[id] ==='99') {
                statusStr = '入庫無し';
              } else{
                statusStr = ReasonType.valueOf(item[id]).text;
              }
              csv += statusStr + '","';
            } else{
              csv += item[id] + '","';
            }
          }
        }
        csv = csv.substring(0, csv.length - 2);
        csv += '\n';
      }
      const blob = new Blob([csv], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    changeShippingMode(){
      if(this.shippingMode === '1'){
        this.shippingMode = '2';
      } else{
        this.shippingMode = '1';
      }
      this.isIncludeLargeItem = false;
      this.items = [];
    },
    // registerShipmentForNormal(){
    //   this.indicateCarrier = 'normal';
    //   this.registerShipment();
    // },
    registerShipmentForDHL(){
      this.indicateCarrier = 'dhl';
      this.registerShipment();
    },
    registerShipmentForUPS(){
      this.indicateCarrier = 'ups';
      this.registerShipment();
    },
    // registerShipmentForIrai(){
    //   this.isIraiRequest = true;
    //   this.registerShipment();
    // },
    registerShipment() {
      const itemMap = new Map();
      this.items.forEach(item => {
        if((item.status === '' || item.status === '05') && item.quantity > 0 && item.delete === false){
          if(itemMap.has(item.sku)){
            let itemTmp = itemMap.get(item.sku);
            itemTmp.quantity = parseInt(itemTmp.quantity, 10) + parseInt(item.quantity, 10);
            itemMap.set(item.sku, itemTmp);
          } else{
            var itemCopy = Object.assign({}, item);
            itemMap.set(itemCopy.sku, itemCopy);
          }
        }
      });
      var a0 = new Array();
      var a1 = '';
      for(let [key, item] of itemMap){
        if(item.quantity != 0 && item.quantity != item.inboundQuantity){
          a0.push(item.sku);
          if(a1 === ''){
            a1 = item.sku;
          } else{
            a1 = a1 + ',' + item.sku;
          }
        }
      }
      if(a0.length > 0){
        this.confirmMessage = '入庫数と数量が不一致なSKUが含まれています。納品処理を継続しますか？（SKU: ' + a1 + ')';
        this.$refs.messageQuantityCheck.show();
        return;
      }
      this.shipmentCore();
    },
    shipmentNotCheckMatome(){
      this.isRequiredCheckMatomeOver20 = false;
      this.shipmentCore();
    },
    shipmentCore(){
      let outputItems = this.items.filter(item => {
        return ((item.status === '' || item.status === '05') && item.quantity > 0 && item.delete === false);
      });
      // console.log("納品seiko-");
      api.registerShipment(this.memberId, this.boxDepth, this.boxWidth, this.boxHeight, this.boxWeight, this.selected, this.traceNumber, outputItems, null, this.shippingMode, this.boxSizeFilter, this.isIncludeLargeItem, this.isRequiredCheckMatomeOver20, this.isIraiRequest, this.indicateCarrier, (item) => {
        // 特殊便かつ20万円を超過した場合のチェック
        this.isRequiredCheckMatomeOver20 = true;
        if(item.isMatomeOver20){
          this.confirmMessage = '特殊便かつ20万円を超過しています。発送処理を続けますか？';
          this.$refs.confirmMessageForMatome20.show();
          return;
        }
        if(item.isAmountLimitOver){
          this.confirmMessage = '指定金額を超えています。商品数を減らしてください。';
          this.$refs.confirmMessage.show();
          return;
        }
        var shipmentId = item.shipmentId;
        this.boxSizeStr = this.boxSizeStr + " (" + item.boxSizeStr + ")";
        this.boxWeightPound = item.boxWeightPound;
        var totalAddress = item.totalAddress;
        var invoiceUrl = item.invoiceUrl;
        this.shipmentId = shipmentId;
        this.addressInfo = totalAddress;
        this.invoiceUrl = invoiceUrl;
        this.selectedShipmentType = item.shipmentType;
        this.confirmMessage = 'Amazonへ納品登録しました。続いて、追跡番号を登録してください。(' + item.shipmentId + ')';
        this.$refs.confirmMessage.show();
      });
    },
    registerShipmentForMultiBoxNormal() {
      this.isIraiRequest = false;
      this.registerShipmentForMultiBox();
    },
    registerShipmentForMultiBoxIrai() {
      this.isIraiRequest = true;
      this.registerShipmentForMultiBox();
    },
    registerShipmentForMultiBox() {
      let isOk = true;
      const itemMap = new Map();
      for (let item of this.items) {
        if((item.status === '' || item.status === '05') && item.delete === false && item.quantity > 0){
          // ボックス番号チェックを実施
          if(item.boxNumber === '' || item.boxNumber < 1){
            this.confirmMessage = '箱番号に未入力、若しくは不正値が設定されています。(' + item.fnsku + ')';
            this.$refs.confirmMessage.show();
            isOk = false;
            break;
          }
          // 発送処理対象のリストを作成する
          if(itemMap.has(item.sku)){
            let itemTmp = itemMap.get(item.sku);
            itemTmp.quantity = parseInt(itemTmp.quantity, 10) + parseInt(item.quantity, 10);
            itemMap.set(item.sku, itemTmp);
          } else{
            var itemCopy = Object.assign({}, item);
            itemMap.set(itemCopy.sku, itemCopy);
          }
        }
      }
      if(!isOk){
        return;
      }
      var a0 = new Array();
      var a1 = '';
      for(let [key, item] of itemMap){
        if(item.quantity != 0 && item.quantity != item.inboundQuantity){
          a0.push(item.sku);
          if(a1 === ''){
            a1 = item.sku;
          } else{
            a1 = a1 + ',' + item.sku;
          }
        }
      }
      if(a0.length > 0){
        this.confirmMessage = '入庫数と数量が不一致なSKUが含まれています。納品処理を継続しますか？（SKU: ' + a1 + ')';
        this.$refs.messageQuantityCheckForMulti.show();
        return;
      }
      this.shipmentCoreForMulti();
    },
    dispBoxInfoMessage(){
      var msg = '(高x幅x奥) ' + this.boxSizeStr + '  (重量) ' + this.boxWeightPound;
      return msg;
    },
    shipmentCoreForMulti(){
      let isOk = true;
      let outputItems = [];
      for (let item of this.items) {
        if((item.status === '' || item.status === '05') && item.delete === false && item.quantity > 0){
          // ボックス番号チェックを実施
          if(item.boxNumber === '' || item.boxNumber < 1){
            this.confirmMessage = '箱番号に未入力、若しくは不正値が設定されています。(' + item.fnsku + ')';
            this.$refs.confirmMessage.show();
            isOk = false;
            break;
          }
          // 発送処理対象のリストを作成する
          outputItems.push(item);
        }
      }
      if(!isOk){
        return;
      }
      let boxSizes = [];
      let sizeBoxList1 = {};
      sizeBoxList1['boxNumber'] = 1;
      sizeBoxList1['boxHeight'] = this.boxHeight1;
      sizeBoxList1['boxWidth'] = this.boxWidth1;
      sizeBoxList1['boxDepth'] = this.boxDepth1;
      sizeBoxList1['boxWeight'] = this.boxWeight1;
      sizeBoxList1['boxSizeFilter'] = this.boxSizeFilter1;
      let sizeBoxList2 = {};
      sizeBoxList2['boxNumber'] = 2;
      sizeBoxList2['boxHeight'] = this.boxHeight2;
      sizeBoxList2['boxWidth'] = this.boxWidth2;
      sizeBoxList2['boxDepth'] = this.boxDepth2;
      sizeBoxList2['boxWeight'] = this.boxWeight2;
      sizeBoxList2['boxSizeFilter'] = this.boxSizeFilter2;
      let sizeBoxList3 = {};
      sizeBoxList3['boxNumber'] = 3;
      sizeBoxList3['boxHeight'] = this.boxHeight3;
      sizeBoxList3['boxWidth'] = this.boxWidth3;
      sizeBoxList3['boxDepth'] = this.boxDepth3;
      sizeBoxList3['boxWeight'] = this.boxWeight3;
      sizeBoxList3['boxSizeFilter'] = this.boxSizeFilter3;
      let sizeBoxList4 = {};
      sizeBoxList4['boxNumber'] = 4;
      sizeBoxList4['boxHeight'] = this.boxHeight4;
      sizeBoxList4['boxWidth'] = this.boxWidth4;
      sizeBoxList4['boxDepth'] = this.boxDepth4;
      sizeBoxList4['boxWeight'] = this.boxWeight4;
      sizeBoxList4['boxSizeFilter'] = this.boxSizeFilter4;
      let sizeBoxList5 = {};
      sizeBoxList5['boxNumber'] = 5;
      sizeBoxList5['boxHeight'] = this.boxHeight5;
      sizeBoxList5['boxWidth'] = this.boxWidth5;
      sizeBoxList5['boxDepth'] = this.boxDepth5;
      sizeBoxList5['boxWeight'] = this.boxWeight5;
      sizeBoxList5['boxSizeFilter'] = this.boxSizeFilter5;
      let sizeBoxList6 = {};
      sizeBoxList6['boxNumber'] = 6;
      sizeBoxList6['boxHeight'] = this.boxHeight6;
      sizeBoxList6['boxWidth'] = this.boxWidth6;
      sizeBoxList6['boxDepth'] = this.boxDepth6;
      sizeBoxList6['boxWeight'] = this.boxWeight6;
      sizeBoxList6['boxSizeFilter'] = this.boxSizeFilter6;
      boxSizes.push(sizeBoxList1);
      boxSizes.push(sizeBoxList2);
      boxSizes.push(sizeBoxList3);
      boxSizes.push(sizeBoxList4);
      boxSizes.push(sizeBoxList5);
      boxSizes.push(sizeBoxList6);

// console.log("納品seiko-M");
      api.registerShipment(this.memberId, null, null, null, null, this.selected, this.traceNumber, outputItems, boxSizes, this.shippingMode, null, this.isIncludeLargeItem, false, this.isIraiRequest, (item) => {
        this.isRequiredCheckMatomeOver20 = true;
        var shipmentId = item.shipmentId;
        var totalAddress = item.totalAddress;
        var invoiceUrl = item.invoiceUrl;
        this.shipmentId = shipmentId;
        this.addressInfo = totalAddress;
        this.invoiceUrl = invoiceUrl;
        this.selectedShipmentType = item.shipmentType;
        // this.totalRows = this.items.length;
        this.confirmMessage = 'Amazonへ納品登録しました。続いて、追跡番号を登録してください。(' + item.shipmentId + ')';
        this.$refs.confirmMessage.show();
      });
    },
    resetShipment(){
      api.resetShipment(this.memberId, this.shipmentId, (item) => {
        var _shipmentId = this.shipmentId;
        this.shipmentId = '';
        this.addressInfo = '';
        this.invoiceUrl = '';
        this.boxSizeStr = '',
        this.boxWeightPound = '',
        this.confirmMessage = '納品#1の処理を取り消しました。(' + _shipmentId + ')';
        this.$refs.confirmMessage.show();
      });
    },
    registerShipmentAfter(){
      api.registerShipmentAfter(this.memberId, this.shipmentId, this.traceNumber, null, this.shippingMode, (item) => {
        var shipmentId = item.shipmentId;
        var shipmentLabelUrl = item.shipmentLabelUrl;
        this.shipmentLabelUrl = shipmentLabelUrl;
        this.items = [];
        this.itemsForMulti = [];
        this.shipmentId = '';
        this.addressInfo = '';
        this.invoiceUrl = '';
        this.selectedImageUrl = '';
        this.boxHeight = '';
        this.boxWidth = '';
        this.boxDepth = '';
        this.selectedShipmentType = '';
        this.boxSizeFilter = '99';
        this.boxSizeFilter1 = '99';
        this.boxSizeFilter2 = '99';
        this.boxSizeFilter3 = '99';
        this.boxSizeFilter4 = '99';
        this.boxSizeFilter5 = '99';
        this.boxSizeFilter6 = '99';
        this.traceNumber = '';
        this.traceNumber1 = '';
        this.traceNumber2 = '';
        this.traceNumber3 = '';
        this.traceNumber4 = '';
        this.traceNumber5 = '';
        this.traceNumber6 = '';
        this.boxWeight = '';
        this.boxWeight1 = '';
        this.boxWeight2 = '';
        this.boxWeight3 = '';
        this.boxWeight4 = '';
        this.boxWeight5 = '';
        this.boxWeight6 = '';
        this.boxSizeStr = '',
        this.boxWeightPound = '',
        this.isIncludeLargeItem = false;
        // this.totalRows = this.items.length;
        // this.hasShippment = true;
        this.deposit = item.deposit;
        this.requireDeposit = item.requireDeposit;
        this.fnumShipping = item.fnumShipping;
        this.numMatome = item.totalInboundQuantityMatome;
        this.isWarnDeposit = item.isWarnDeposit;
        this.totalInboundQuantity = item.totalInboundQuantity;
        this.selected = '0';
        //
        this.confirmMessage = 'Amazonへの納品登録が完了しました。(' + item.shipmentId + ')';
        this.$refs.confirmMessage.show();
      });
    },
    registerShipmentAfterForMulti(){

      let traceNumberList = {};
      traceNumberList['traceNumber1'] = this.traceNumber1;
      traceNumberList['traceNumber2'] = this.traceNumber2;
      traceNumberList['traceNumber3'] = this.traceNumber3;
      traceNumberList['traceNumber4'] = this.traceNumber4;
      traceNumberList['traceNumber5'] = this.traceNumber5;
      traceNumberList['traceNumber6'] = this.traceNumber6;

      api.registerShipmentAfter(this.memberId, this.shipmentId, 'dummy', traceNumberList, this.shippingMode, (item) => {
        var shipmentId = item.shipmentId;
        var shipmentLabelUrl = item.shipmentLabelUrl;
        this.shipmentLabelUrl = shipmentLabelUrl;
        this.items = [];
        this.itemsForMulti = [];
        this.shipmentId = '';
        this.addressInfo = '';
        this.invoiceUrl = '';
        this.selectedImageUrl = '';
        this.boxSizeFilter = '99';
        this.boxSizeFilter1 = '99';
        this.boxSizeFilter2 = '99';
        this.boxSizeFilter3 = '99';
        this.boxSizeFilter4 = '99';
        this.boxSizeFilter5 = '99';
        this.boxSizeFilter6 = '99';
        this.traceNumber = '';
        this.traceNumber1 = '';
        this.traceNumber2 = '';
        this.traceNumber3 = '';
        this.traceNumber4 = '';
        this.traceNumber5 = '';
        this.traceNumber6 = '';
        this.boxWeight = '';
        this.boxWeight1 = '';
        this.boxWeight2 = '';
        this.boxWeight3 = '';
        this.boxWeight4 = '';
        this.boxWeight5 = '';
        this.boxWeight6 = '';
        this.boxSizeStr = '',
        this.boxWeightPound = '',
        this.isIncludeLargeItem = false;
        // this.totalRows = this.items.length;
        // this.hasShippment = true;
        this.deposit = item.deposit;
        this.requireDeposit = item.requireDeposit;
        this.fnumShipping = item.fnumShipping;
        this.numMatome = item.totalInboundQuantityMatome;
        this.isWarnDeposit = item.isWarnDeposit;
        this.totalInboundQuantity = item.totalInboundQuantity;
        this.selected = '0';
        //
        this.confirmMessage = 'Amazonへの納品登録が完了しました。(' + item.shipmentId + ')';
        this.$refs.confirmMessage.show();
      });
    },
    changeToReInboundMode(){
      this.isReInboundMode = true;
    },
    troubleModal(row) {
      // this.editItem = {};
      this.editItem =  Object.assign({}, this.editItem , row.item);
      this.rowCopy =  row.item;
      // Object.assign(this.editItem , row.item);
      this.$refs.troubleModal.show();
    },
    handleTroubleOk() {
      api.registerShippingTrouble(this.memberId, this.editItem, this.selectedTroubleType, this.reasonCodeOther, this.locationNumber, (data) => {
        if(this.selectedTroubleType !== '0'){
          this.rowCopy.status = this.rowCopy.status + ',' + this.selectedTroubleType;
        }
        this.troubleProductInfo = data.troubleProductIdInfo;
        this.confirmMessage = '管理表への登録が完了しました。続いてラベルを印刷して下さい' ;
        this.$refs.messagePopup.show();
      });
    },
    handleTroblePrintOk(){
      // ラベル出力
      let item = this.troubleProductInfo;
      const WinPrint = window.open('', '', 'width=500,height=555,scrollbars=0,menuBar=0,toolbar=0,location=0,status=0');

      let reasonCode = item.reasonCode;
      let reasonName = ReasonType.valueOf(reasonCode).text;
      if(reasonCode === '12'){
        if(item.reasonCodeOther != null && item.reasonCodeOther.length > 35){
          reasonName = reasonName + '（' + item.reasonCodeOther.substr(0,35) + '）';
        } else{
          reasonName = reasonName + '（' + item.reasonCodeOther + '）';
        }
      }
      let quantity = item.troubleQuantity;
      let troubleId = item.troubleProductId;
      let memberId = item.memberId;
      let trackingNumber = item.trackingNumber;
      if(trackingNumber == null || trackingNumber === ''){
        trackingNumber = '-';
      }
      let url = item.barcodeUrl;
      let locationNumberStr = '-';
      if(this.locationNumber !== ''){
        locationNumberStr = this.locationNumber;
      }
      var printUrl = '<div style="text-align:center"><img src="' + url + '" width="195" height="40" class=""></div><div style="font-size:9px;text-align:center;margin-top:1px;padding:0">' + troubleId + ' (Localtion: ' + locationNumberStr + ')</div><div style="height:5px;font-size:9px;text-align:center;margin-top:0px;padding:0">[slcuser' + memberId + '/数:' + quantity +'/追跡:' + trackingNumber + ']<br>' + reasonName + '</div>';
      WinPrint.document.body.innerHTML = printUrl;

      const sleep = (waitSeconds) => {
        return new Promise(resolve => {
          setTimeout(() => {
            WinPrint.window.print();
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.close();
          }, waitSeconds)
        })
      }
      sleep(500);
    },
    getInvoiceCSV(){
      this.confirmMessage = '実際の残数を入力確認してください。';
      this.$refs.checkStockVolume.show();
    },
    checkStockVolume(){
      if(this.wkDispRestVolume != this.inputStockVolume){
        this.confirmMessage = '残数が一致しません入庫画面を確認してください。';
        this.$refs.checkStockVolumeResult.show();
        return;
      }
      this.getInvoiceCSVCore();
    },
    getInvoiceCSVCore(){
      api.getInvoice(this.invoiceUrl, (item) => {
        var blob = new Blob([item], {type: 'text/csv'});
        var url = window.URL.createObjectURL(blob);
        let anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = this.invoiceUrl;
        anchor.click();
        window.URL.revokeObjectURL(url);
      });
    },
    getShipmentLabel(){
      // if(this.shipmentId === ''){
      //   return;
      // }
      if(this.shipmentLabelUrl === ''){
        api.getShipmentLabelURL(this.shipmentId, (item) => {
          if(item.shipmentLabelUrl === ''){
            this.shipmentId = '';
            return;
          }
          let anchor = document.createElement('a');
          anchor.href = item.shipmentLabelUrl;
          anchor.target = '_blank';
          anchor.click();
          this.shipmentId = '';
        });
      } else{
        let anchor = document.createElement('a');
        anchor.href = this.shipmentLabelUrl;
        anchor.target = '_blank';
        anchor.click();
        this.shipmentId = '';
      }
    },
    selectImage(url) {
      this.selectedImageUrl = url;
    },
    updateItemQuantity(event){
      this.itemQuantity = event;
    },
    changeBoxSizeFilter(event, key){
      var bh = '';
      var bw = '';
      var bd = '';
      if(event === '1'){
        bh = '42';
        bw = '32';
        bd = '34';
      } else if(event === '2'){
        bh = '54';
        bw = '37';
        bd = '37';
      } else if(event === '3'){
        // bh = '61.5';
        // bw = '41.5';
        // bd = '41.5';
        bh = '63';
        bw = '42';
        bd = '42';
      // } else if(event === '4'){
      //   bh = '48';
      //   bw = '77';
      //   bd = '38';
      } else if(event === '5'){
        bh = '52';
        bw = '62';
        bd = '53';
      } else if(event === '6'){
        // bh = '42';
        // bw = '50';
        // bd = '42';
        bh = '44';
        bw = '50';
        bd = '42';
      } else if(event === '7'){
        bh = '43';
        bw = '37';
        bd = '38';
      } else if(event === '8'){
        bh = '55';
        bw = '45';
        bd = '42';
      } else if(event === '9'){
        bh = '21';
        bw = '34';
        bd = '34';
      } else if(event === '10'){
        bh = '21';
        bw = '34';
        bd = '34';
      } else if(event === '99'){
        bh = '';
        bw = '';
        bd = '';
      }

      if(key === 0){
        this.boxHeight = bh;
        this.boxWidth = bw;
        this.boxDepth = bd;
      } else if (key === 1){
        this.boxHeight1 = bh;
        this.boxWidth1 = bw;
        this.boxDepth1 = bd;
      } else if (key === 2){
        this.boxHeight2 = bh;
        this.boxWidth2 = bw;
        this.boxDepth2 = bd;
      } else if (key === 3){
        this.boxHeight3 = bh;
        this.boxWidth3 = bw;
        this.boxDepth3 = bd;
      } else if (key === 4){
        this.boxHeight4 = bh;
        this.boxWidth4 = bw;
        this.boxDepth4 = bd;
      } else if (key === 5){
        this.boxHeight5 = bh;
        this.boxWidth5 = bw;
        this.boxDepth5 = bd;
      } else if (key === 6){
        this.boxHeight6 = bh;
        this.boxWidth6 = bw;
        this.boxDepth6 = bd;
      }
    },
    changeBoxSizeFilterNew(event, key){
      var bh = '';
      var bw = '';
      var bd = '';
      var boxSizeTypeValue = '99';

      if(event === '120'){
        bh = '54';
        bw = '37';
        bd = '37';
        boxSizeTypeValue = '2';
      } else if(event === '140'){
        bh = '63';
        bw = '42';
        bd = '42';
        boxSizeTypeValue = '3';
      } else if(event === '160B'){
        bh = '52';
        bw = '62';
        bd = '53';
        boxSizeTypeValue = '5';
      } else if(event === 'DHL5'){
        bh = '35.5';
        bw = '33';
        bd = '35.5';
        boxSizeTypeValue = '11';
      } else if(event === 'DHL6'){
        // bh = '43'; *7/20 終了
        // bw = '37'; *7/20 終了
        // bd = '38'; *7/20 終了
        bh = '45';
        bw = '41';
        bd = '40';
        boxSizeTypeValue = '7';
      } else if(event === 'DHL7'){
        bh = '44';
        bw = '50';
        bd = '42';
        boxSizeTypeValue = '6';
      } else if(event === 'SIZE7'){
        bh = '44';
        bw = '51.5';
        bd = '43.5';
        boxSizeTypeValue = '13';
      } else if(event === 'TOKUSYU'){
        bh = '21';
        bw = '34';
        bd = '34';
        boxSizeTypeValue = '9';
      } else if(event === 'WATCH-SHOKAI'){
        bh = '21';
        bw = '34';
        bd = '34';
        boxSizeTypeValue = '12';
        this.boxWeight = '3';
      } else {
        bh = '';
        bw = '';
        bd = '';
        boxSizeTypeValue = '99';
      }

      if(key === 0){
        this.boxHeight = bh;
        this.boxWidth = bw;
        this.boxDepth = bd;
        this.boxSizeFilter = boxSizeTypeValue;
      } else if (key === 1){
        this.boxHeight1 = bh;
        this.boxWidth1 = bw;
        this.boxDepth1 = bd;
        this.boxSizeFilter1 = boxSizeTypeValue;
      } else if (key === 2){
        this.boxHeight2 = bh;
        this.boxWidth2 = bw;
        this.boxDepth2 = bd;
        this.boxSizeFilter2 = boxSizeTypeValue;
      } else if (key === 3){
        this.boxHeight3 = bh;
        this.boxWidth3 = bw;
        this.boxDepth3 = bd;
        this.boxSizeFilter3 = boxSizeTypeValue;
      } else if (key === 4){
        this.boxHeight4 = bh;
        this.boxWidth4 = bw;
        this.boxDepth4 = bd;
        this.boxSizeFilter4 = boxSizeTypeValue;
      } else if (key === 5){
        this.boxHeight5 = bh;
        this.boxWidth5 = bw;
        this.boxDepth5 = bd;
        this.boxSizeFilter5 = boxSizeTypeValue;
      } else if (key === 6){
        this.boxHeight6 = bh;
        this.boxWidth6 = bw;
        this.boxDepth6 = bd;
        this.boxSizeFilter6 = boxSizeTypeValue;
      }
    },
    getCommentList(item) {
      let commentList = [];
      // 有効なレコードの処理
      if(item['comment']){
        for (const v of item['comment'].split(',')) {
          commentList.push(v);
        }
      }
      return commentList;
    },
    culcPurchaseAmount(item){
      var total = item['price'] * utility.toNumber(item['quantity']);
      return total;
    },
    addCellVariant(items) {
      this.hasErrors = false;
      for (const v of items) {
        const errorCells = [];
        if (v['fnsku'].substring(0,1) === 'B') {
          errorCells['fnsku'] = 'danger';
        }
        v['_cellVariants'] = errorCells;
      }
    },
    getStatusList(item) {
      let statusList = [];
      // 有効なレコードの処理
      if(item['status']){
        for (const v of item['status'].split(',')) {
          var statusTxt = ReasonType.valueOf(v).text;
          if(statusTxt === '-'){
            continue;
          }
          statusList.push(statusTxt);
          continue;
          // if (v ==='01') {  statusList.push('SKU登録無し'); continue; }
          // if (v ==='02') {  statusList.push('ASIN無効'); continue;}
          // if (v ==='04') {  statusList.push('LAS登録無し'); continue;}
          // if (v ==='05') {  statusList.push('返品依頼'); continue;}
          // if (v ==='06') {  statusList.push('廃棄依頼'); continue;}
          // if (v ==='07') {  statusList.push('数量不一致'); continue;}
          // if (v ==='08') {  statusList.push('修正削除依頼'); continue;}
          // if (v ==='09') {  statusList.push('サイズ無し'); continue;}
          // if (v ==='10') {  statusList.push('輸出不可'); continue;}
          // if (v ==='11') {  statusList.push('SDSが必要'); continue;}
          // if (v ==='13') {  statusList.push('出品許可要'); continue;}
          // if (v ==='14') {  statusList.push('有効な出品情報無し'); continue;}
          // if (v ==='15') {  statusList.push('特殊便5Kg上限'); continue;}
          // if (v ==='16') {  statusList.push('セット登録なし'); continue;}
          // if (v ==='17') {  statusList.push('JANなし商品'); continue;}
          // if (v ==='98') {  statusList.push('エラー有'); continue;}
          // if (v ==='99') {  statusList.push('入庫無し');}
        }
      }
      // 有効なレコードの処理
      if(item['statusOther']){
        for (const v of item['statusOther'].split(',')) {
          statusList.push('その他(' + v + ')');
        }
      }
      return statusList;
    },
  },
};

Vue.component('seller-select-modal', SellerSelectModal);
Vue.component('shipment-plan-summary', ShipmentPlanSummary);
Vue.component('shipment-plan-deposit', ShipmentPlanDeposit);

</script>

<style>
.right-aligned {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px; /* チェックボックスとボタンの間のスペース */
  margin-top: 10px; /* モーダル内の他の要素とのスペース調整 */
}
.modal-divider {
  border: none;
  border-top: 1px solid #ccc; /* 線のスタイル */
  margin: 10px 0; /* 線の上下のマージン */
}
.component-margin {
  margin-bottom: 1rem;
}
.component-margin-2r {
  margin-bottom: 2rem;
}
.component-margin-top{
  margin-top: 1.5rem;
}
.component-margin-left {
  margin-left: 1rem;
}
.component-margin-top-half{
  margin-top: 0.75rem;
}
.component-margin-top-half2{
  margin-top: 0.5rem;
}
.box-item{
  width: 3rem;
  display: inline-block;
  margin-top: 0.1rem;
}
.box-selected{
  width: 5rem;
  display: inline-block;
}
.box-tracking{
  width: 15rem;
  display: inline-block;
}
.box-item-weight{
  width: 3rem;
  display: inline-block;
  margin-left: 1rem;
}

.big-box{
  height: 8rem;
  padding: 1.5rem;
}
.width-max{
  width: 100%;
}
.shipping-btn{
  width: 100%;
  height: 2rem;
  padding: 0;
}
.shipping-btn-size{
  width: 2rem;
  height: 2rem;
  margin-left: 1rem;
  padding: 0;
}
.width-90{
  width: 90%;
}
.big-checkbox{
  width: 1.5rem;
  height: 1.5rem;
  margin-top: .5rem;
}
.text-window {
  padding: 1em;
  background-color: lightblue;
}
.text-window-orange{
  padding: 1em;
  background-color: orange;
}
.padding-off{
  padding-left: 0;
  padding-right: 0;
}
.padding-right-off{
  padding-right: 0;
}
.padding-left-off{
  padding-left: 0;
}
.margin-bottom-off{
  margin-bottom: 0;
}
.height-2{
  height: 2rem!important;
}

.mark-carrier-blue {
    background-color: blue;
    color: white;
    border-radius: 0.3rem;
    font-size: .875rem;
    padding: 0.25rem;
    font-weight: 700;
}

.mark-carrier-red {
    background-color: red;
    color: white;
    border-radius: 0.3rem;
    font-size: .875rem;
    padding: 0.25rem;
    font-weight: 700;
}

.mark-carrier-gray {
    background-color: gray;
    color: white;
    border-radius: 0.3rem;
    font-size: .875rem;
    padding: 0.25rem;
    font-weight: 700;
}

.message-box {
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
  text-align: center;
  font-size: large;
  display: inline-block;
  width: 100%
}

.message-warn {
  background-color: red;
  color: white;
  font-weight: bold;
}

table > thead > tr > th {
  text-align: center!important;
}

table label{
  margin-bottom: 0;
}
table .image{
  height: 3rem;
  width: 3rem;
}

@media (min-width: 768px) {
  .table-label { margin-top: 0.3rem; margin-bottom: 0.3rem; }
  .table-linput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: left; }
  .table-rinput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: right; }
  .table-lw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:left; }
  .table-lw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:left; }
  .table-lw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:left; }
  .table-lw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:left; }
  .table-lw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:left; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left; }
  .table-lw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:left; }
  .table-lw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:left; }
  .table-lw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:left; }
  .table-lw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:left; }
  .table-lw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:left; }
  .table-lw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:left; }
  .table-lw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:left; }
  .table-lw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:left; }
  .table-lw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:left; }
  .table-lw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:left; }
  .table-lw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:left; }
  .table-lw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:left; }
  .table-lw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:left; }
  .table-rw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:right; }
  .table-rw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:right; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right; }
  .table-rw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:right; }
  .table-rw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:right; }
  .table-rw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:right; }
  .table-rw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:right; }
  .table-rw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:right; }
  .table-rw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:right; }
  .table-rw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:right; }
  .table-rw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:right; }
  .table-rw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:right; }
  .table-rw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:right; }
  .table-rw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:right; }
  .table-rw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:right; }
  .table-rw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:right; }
  .table-rw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:right; }
  .table-rw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:right; }
  .table-rw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:right; }
  .table-cw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:center; }
  .table-cw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:center; }
  .table-cw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:center; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
  .table-cw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:center; }
  .table-cw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:center; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center; }
  .table-cw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:center; }
  .table-cw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:center; }
  .table-cw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:center; }
  .table-cw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:center; }
  .table-cw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:center; }
  .table-cw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:center; }
  .table-cw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:center; }
  .table-cw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:center; }
  .table-cw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:center; }
  .table-cw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:center; }
  .table-cw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:center; }
  .table-cw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:center; }
}
</style>
